module.exports = __webpack_public_path__ + "static/media/top100SoftwareCompanies2020.91bcf668.png";